import { LogOut, ShieldAlert, User as UserIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { useSession } from '@/auth/session';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? parts[parts.length - 1]?.[0] ?? '' : '';
  return (first + last).toUpperCase() || '?';
}

export function UserMenu() {
  const { user, pharmacy, logout } = useSession();
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-2.5 rounded-full py-1 pl-1 pr-3 text-left transition-colors hover:bg-secondary">
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-grad-primary text-xs font-semibold text-white">
          {initials(user.name)}
        </div>
        <div className="hidden text-left sm:block">
          <p className="text-sm font-medium leading-tight">{user.name}</p>
          <p className="text-xs leading-tight text-muted-foreground">
            {user.role === 'Superadmin' ? 'Platform admin' : pharmacy?.name ?? user.role}
          </p>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>
          <p className="truncate font-normal text-muted-foreground">{user.email}</p>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate('/settings')}>
          <UserIcon /> Account settings
        </DropdownMenuItem>
        {user.role === 'Superadmin' && (
          <DropdownMenuItem onClick={() => navigate('/superadmin')}>
            <ShieldAlert /> Platform admin
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => {
            logout();
            navigate('/login', { replace: true });
          }}
          className="text-status-expired focus:bg-status-expired/10 focus:text-status-expired"
        >
          <LogOut /> Log out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
